module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/vercel/workpath0/lessons/10.mdx",
    "dirname": "/vercel/workpath0/lessons"
  }
}];